/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { EditorialStepsSection } from 'ui/molecules/EditorialStepsSection/EditorialStepsSection';
import { HeroSection } from 'ui/molecules/HeroSection/HeroSection';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

import styles from './MaActivityPage.module.scss';

import { MaActivityFeaturesSection } from './MaActivityFeaturesSection/MaActivityFeaturesSection';
import { MaActivityHeroCard } from './MaActivityHeroCard/MaActivityHeroCard';
import { MaActivityDemoSection } from './MaActivityDemoSection/MaActivityDemoSection';
import { MaActivityMidCtaSection } from './MaActivityMidCtaSection/MaActivityMidCtaSection';
import { MaActivityUseCasesSection } from './MaActivityUseCasesSection/MaActivityUseCasesSection';
import { MaActivityCompareSection } from './MaActivityCompareSection/MaActivityCompareSection';
import { getMaActivityFaq, getMaActivityWhySteps } from './MaActivityPage.data';

export const MaActivityPage = () => {
  const { t } = useInt();
  const { secondaryNavigation } = useContext(ContentContext);
  const bookDemoSlug = secondaryNavigation?.book_demo?.slug;

  const whySteps = getMaActivityWhySteps(t);
  const faq = getMaActivityFaq(t);

  return (
    <div className={styles.wrapper}>
      <div className={styles.heroBand}>
        <HeroSection
          align="left"
          mediaPosition="right"
          background="transparent"
          title={t('Uncover the full deal history. Instantly.')}
          description={t('Every acquisition, funding round, investor, and exit — mapped in one company profile.')}
          actions={
            bookDemoSlug && (
              <Button type="blue" size="xxl" route={bookDemoSlug}>
                {t('Explore M&A activity')}
              </Button>
            )
          }
          media={<MaActivityHeroCard />}
          mediaClassName={styles.heroMedia}
        />

        <OurCustomersV2 hasBackground={false} />
      </div>

      <MaActivityFeaturesSection />

      <MaActivityUseCasesSection />

      <MaActivityDemoSection />

      <MaActivityMidCtaSection />

      <EditorialStepsSection title={t('Built for M&A research on the whole market.')} steps={whySteps} />

      <MaActivityCompareSection />

      <CtaSection
        spotlight
        title={t('The complete M&A picture.')}
        description={t(
          'Acquisitions, funding, investors, and the signals behind the next move — for any company, market, or sector.',
        )}
        actions={
          bookDemoSlug && (
            <Button type="blue" size="xxl" route={bookDemoSlug}>
              {t('Book a demo')}
            </Button>
          )
        }
      />

      <Faq title={t('Frequently asked questions')} data={faq} />
    </div>
  );
};
